import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HasPlansPipeModule } from 'src/app/shared/pipes/has-plans';
import { NoPredictiveintentTopicsComponent } from './no-predictiveintent-topics.component';

import {  MatButtonModule } from '@angular/material/button';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule,
        HasPlansPipeModule,
        MatButtonModule
    ],
    declarations: [NoPredictiveintentTopicsComponent],
    exports: [NoPredictiveintentTopicsComponent]
})
export class NoPredictiveintentTopicsModule {}
